<template>
  <div class="goods_manage_wrap">
    <div class="header">
      <el-col :span="19">
        <el-button type="primary" size="medium" class="left-line" @click="toGoodsManageAdd">新增</el-button>
        <el-select v-model="listQuery.typeCode" placeholder="请选择分类" size="medium" @change="getIntegralGoodsPageList">
          <el-option label="全部分类" :value="''"></el-option>
          <el-option v-for="(item, index) in typeList" :key="index" :label="item.value" :value="item.code"></el-option>
        </el-select>
        <el-select v-model="listQuery.goodsStatus" placeholder="请选择上架状态" size="medium" @change="getIntegralGoodsPageList">
          <el-option v-for="(item, index) in statusList" :key="index" :label="item" :value="index"></el-option>
        </el-select>
      </el-col>
      <el-col :span="5">
        <el-input placeholder="请输入商品名称" size="medium" v-model.trim="listQuery.goodsName" @change="getIntegralGoodsPageList">
          <el-button slot="append" icon="el-icon-search" @click="getIntegralGoodsPageList"></el-button>
        </el-input>
      </el-col>
    </div>
    <el-table stripe :data="dataList" :height="`${windowHeight - 210}px`" border style="width: 100%">
      <el-table-column align="center" label="商品名称" show-overflow-tooltip>
        <template slot-scope="scope">
          <span style="color:#409eff;cursor: pointer;" @click="toGoodsInfo(scope.row.id)">{{scope.row.goodsName}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="所属分类" prop="typeName" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="所需积分" prop="requirePoint" show-overflow-tooltip></el-table-column>
      <el-table-column align="center" label="图片" show-overflow-tooltip>
        <template slot-scope="scope">
          <image-previewer tag="richtext">
            <img class="picimg" :src="scope.row.goodsLogo" alt="">
          </image-previewer>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.goodsStatus === 2">已上架</span>
          <span v-else>未上架</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="updateStatus(scope.row.id, scope.row.goodsStatus)">{{scope.row.goodsStatus === 2 ? '下架' : '上架'}}</el-button>
          <el-button type="text" @click="deleteHandler(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination class="pagination-container" @size-change="handleSizeChange" @current-change="handleCurrentChange"
      :current-page.sync="listQuery.pageNo" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.pageSize"
      layout="total, sizes, prev, pager, next, jumper" :total="total">
    </el-pagination>
  </div>
</template>

<script>
  import windowResize from "@/mixins/windowResize";
  import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
  import {findDicsByCode} from '@/api/common/common';
  import {getIntegralGoodsPageList, deleteIntegralGoodsById, updateIntegralGoodsStatus} from '@/api/integralBank';

  export default {
    name: "goodsManageList",
    components: {ImagePreviewer},
    data() {
      return {
        typeList: [],
        statusList: ['全部状态', '未上架', '已上架'],
        dataList: [],
        listQuery: {
          pageNo: 1,
          pageSize: 20,
          goodsName: '',
          goodsStatus: 0,
          typeCode: ''
        },
        total: null
      }
    },
    mixins: [windowResize],
    created() {
      this.findDicsByCode();
      this.getIntegralGoodsPageList();
    },
    methods: {
      toGoodsManageAdd() {
        this.$router.push({path: 'goodsManageAdd'})
      },
      toGoodsInfo(id) {
        this.$router.push({path: 'goodsManageInfo', query: {goodsId: id}})
      },
      findDicsByCode() {
        findDicsByCode({dicCode: 'integralGoodsType'}).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.typeList = data.data;
          }
        });
      },
      getIntegralGoodsPageList() {
        getIntegralGoodsPageList(this.listQuery).then(res => res.data).then(data => {
          if (data.code === 200 && data.result) {
            this.dataList = data.data.dataList;
            this.total = data.data.pagination.total;
          }
        });
      },
      deleteHandler(id) {
        this.$confirm("确认要删除当前商品吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          deleteIntegralGoodsById({id: id}).then(res => res.data).then(data => {
            if (data.code === 200 && data.result) {
              this.$message.success('删除成功！');
              this.getIntegralGoodsPageList();
            } else {
              this.$message.error(data.msg);
            }
          })
        });
      },
      updateStatus(id, status) {
        this.$confirm("确认要" + (status===2 ? '下架' : '上架') + "当前商品吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          lockScroll: false
        }).then(() => {
          updateIntegralGoodsStatus({goodsId: id, goodsStatus: (status===2 ? 1 : 2)}).then(res => res.data).then(data => {
            if (data.code === 200 && data.result) {
              this.$message.success((status===2 ? '下架' : '上架') + '成功！');
              this.getIntegralGoodsPageList();
            } else {
              this.$message.error(data.msg);
            }
          })
        });
      },
      //切换码数
      handleSizeChange(val) {
        this.listQuery.pageNo = 1;
        this.listQuery.pageSize = val;
        this.getIntegralGoodsPageList();
      },
      //切换页数
      handleCurrentChange(val) {
        this.listQuery.pageNo = val;
        this.getIntegralGoodsPageList();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .goods_manage_wrap{
    padding: 12px;

    .header {
      padding-bottom: 10px;
      overflow: hidden;
    }
    .picimg{
      display: block;
      width: 28px;
      height: 21px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/integralBank/goodsManageList.vue